import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Registration } from './registration.model';
import { AuthService } from '@shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  readonly registrationStep$: Observable<number>;
  private readonly _registrationStep$ = new BehaviorSubject<number>(1);

  private readonly _authService: AuthService = inject(AuthService);

  constructor() {
    this.registrationStep$ = this._registrationStep$.asObservable();
  }

  setRegistrationStep(step: number): void {
    this._registrationStep$.next(step);
  }

  nextRegistrationStep(): void {
    this._registrationStep$.next(this._registrationStep$.value + 1);
  }

  async registerUser(registrationData: Registration): Promise<void> {
    await this._authService.register(
      registrationData.email,
      registrationData.password,
      registrationData.fullName
    );

    await this._authService.login(
      registrationData.email,
      registrationData.password
    );

    await this._authService.updatePhoneNumber(
      registrationData.mobile,
      registrationData.password
    );

    // I am doing this in the finally
    // await this._authService.logout();
  }
}
